const raSearcheGreekMessages = {
    'ra-search': {
        recent: 'Πρόσφατα',
    },
};

export default raSearcheGreekMessages;
